import { render, staticRenderFns } from "./readonly-field.vue?vue&type=template&id=23256b1e&scoped=true&"
import script from "./readonly-field.vue?vue&type=script&lang=js&"
export * from "./readonly-field.vue?vue&type=script&lang=js&"
import style0 from "./readonly-field.vue?vue&type=style&index=0&id=23256b1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23256b1e",
  null
  
)

export default component.exports